/* Uptown Fleece 2026 — hover / in-view product video.
   Idempotent: safe to load once, binds each element only once, re-inits in the theme editor.
   Videos use the product's own media (native <video>/.mp4). Optional HLS if window.Hls exists. */
(function () {
  'use strict';
  if (window.UptownFleeceLoaded) return; // referenced by multiple sections; init once
  window.UptownFleeceLoaded = true;

  function bindVideo(v) {
    if (v.dataset.ufBound) return;
    v.dataset.ufBound = '1';

    var loaded = false;
    var want = false;

    function load() {
      if (loaded) return;
      loaded = true;
      var src = v.dataset.src;
      if (!src) return;
      if (v.canPlayType('application/vnd.apple.mpegurl') || src.indexOf('.m3u8') === -1) {
        v.src = src; // native mp4/webm, or Safari native HLS
      } else if (window.Hls && window.Hls.isSupported()) {
        var h = new window.Hls();
        v._hls = h;
        h.loadSource(src);
        h.attachMedia(v);
        h.on(window.Hls.Events.MANIFEST_PARSED, tryPlay);
      } else {
        v.src = src;
      }
    }
    function tryPlay() { if (want && v.paused) { var p = v.play(); if (p) p.catch(function () {}); } }
    function stop() { want = false; v.classList.remove('is-playing'); v.pause(); }

    v.addEventListener('playing', function () { if (want) v.classList.add('is-playing'); });
    v.addEventListener('canplay', tryPlay);

    v._ufPlay = function () { want = true; load(); tryPlay(); };
    v._ufStop = stop;

    var card = v.closest('.uf-card') || v.parentElement;
    if (matchMedia('(hover: hover)').matches) {
      card.addEventListener('mouseenter', function () { v._ufPlay(); });
      card.addEventListener('mouseleave', function () { stop(); try { v.currentTime = 0; } catch { /* Video state can be read-only. */ } });
    }
  }

  var io = null;
  function inViewObserver() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.6) e.target._ufPlay && e.target._ufPlay();
        else e.target._ufStop && e.target._ufStop();
      });
    }, { threshold: [0, 0.6] });
    return io;
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var vids = scope.querySelectorAll('.uf-card__video[data-src]');
    var touch = matchMedia('(hover: none)').matches;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    vids.forEach(function (v) {
      if (reduce) return; // honor reduced-motion: no autoplay
      bindVideo(v);
      if (touch) { var o = inViewObserver(); if (o) o.observe(v); }
    });
    scope.querySelectorAll('.uf-card__swatch').forEach(function (b) {
      if (b.dataset.ufc) return; b.dataset.ufc = '1';
      var d = b.querySelector('.uf-card__swatchdot'); if (d) d.style.background = dotColor(b.getAttribute('data-value'));
    });
  }

  /* ---- quick-shop modal: color + size → sets a native product-form's variant id ---- */
  var COLORMAP = {
    red:'#9e2128','true red':'#9e2128', navy:'#232f4c','navy blue':'#232f4c', black:'#171717',
    olive:'#565a34','olive green':'#565a34', wine:'#5a2530', charcoal:'#4d4d50',
    'heather grey':'#b9b9bd','heather gray':'#b9b9bd','h/grey':'#b9b9bd','h/gray':'#b9b9bd',
    hgrey:'#b9b9bd', grey:'#9a9a9e', gray:'#9a9a9e', white:'#f3f3f3', cream:'#efe7d6',
    bone:'#e7e0cf', khaki:'#b9a97f', tan:'#c8ad86', sand:'#cbb693', mocha:'#7c5b41',
    cognac:'#8a4b2b', brown:'#5a3d2b', mint:'#bfe0cf', blush:'#e7c4c2', 'light blue':'#a9c4d6',
    royal:'#20408a', 'royal blue':'#20408a', maroon:'#5a2530', green:'#3f5a34', pink:'#e6a6b8'
  };
  function dotColor(v) { return COLORMAP[String(v || '').toLowerCase().trim()] || '#c9c9cf'; }
  function qsSwapImage(modal) {
    var colors = modal.querySelector('.uf-qs__opt .uf-qs__colors');
    var cpos = colors && colors.getAttribute('data-option-position');
    qsShowImage(modal, qsImgForColor(modal._variants || [], cpos, modal._color, 800));
  }
  function qsMainMatch(modal) {
    var groups = [].slice.call(modal.querySelectorAll('.uf-qs__opt [data-option-position]'));
    var sel = modal._sel || {};
    var missing = null;
    groups.forEach(function (g) { if (!missing && !sel[g.getAttribute('data-option-position')]) missing = g; });
    if (!groups.length || missing) {
      var wrap = missing && missing.closest('.uf-qs__opt');
      var lbl = wrap && wrap.querySelector('.uf-qs__optlabel');
      var name = lbl ? (lbl.childNodes[0].textContent || '').trim() : 'Options';
      return { complete: false, needEl: wrap, needLabel: name };
    }
    var vs = modal._variants || [];
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i], ok = true;
      groups.forEach(function (g) { var p = g.getAttribute('data-option-position'); if (String(v['option' + p]) !== String(sel[p])) ok = false; });
      if (ok) return { complete: true, variant: v };
    }
    return { complete: true, variant: null };
  }
  // A slot returns null when it is switched off, otherwise what it still needs, or its variant.
  function qsSlotMatch(slot) {
    if (!qsSlotOn(slot)) return null;
    if (!slot._vars) return { needPartner: true };
    if (slot._cpos && !slot._color) return { needColor: true };
    if (slot._spos && !slot._size) return { needSize: true };
    for (var i = 0; i < slot._vars.length; i++) {
      var v = slot._vars[i], ok = true;
      if (slot._cpos && String(v['option' + slot._cpos]) !== String(slot._color)) ok = false;
      if (slot._spos && String(v['option' + slot._spos]) !== String(slot._size)) ok = false;
      if (ok) return { variant: v };
    }
    return { variant: null };
  }
  function qsEsc(v) { return String(v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  // parse + cache a partner tile's variants
  function qsVarsFor(pr) {
    if (pr._vars) return pr._vars;
    var sc = pr.closest('.uf-qs').querySelector('.uf-qs__partner-data[data-index="' + pr.getAttribute('data-index') + '"]');
    try { pr._vars = JSON.parse(sc.textContent); } catch { pr._vars = []; }
    return pr._vars;
  }
  function qsColorHasStock(vars, cpos, color) {
    return vars.some(function (v) { return (!cpos || !color || String(v['option' + cpos]) === String(color)) && v.available; });
  }
  function qsImgForColor(vars, cpos, color, width) {
    for (var i = 0; i < vars.length; i++) {
      var v = vars[i];
      if ((!cpos || !color || String(v['option' + cpos]) === String(color)) && v.featured_image && v.featured_image.src) {
        var s = v.featured_image.src; if (s.indexOf('//') === 0) s = 'https:' + s;
        return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + (width || 300);
      }
    }
    return null;
  }
  // The big image follows whatever the shopper is configuring — the main item, or an add-on slot.
  function qsShowImage(modal, src) {
    var img = modal.querySelector('.uf-qs__media img');
    if (!img || !src || img.getAttribute('src') === src) return;
    img.src = src; if (img.srcset) img.srcset = '';
  }
  function qsSlotShowImage(slot, modal) {
    if (!slot._vars) return;
    qsShowImage(modal, qsImgForColor(slot._vars, slot._cpos, slot._color, 800));
  }
  function qsSlots(modal) { return [].slice.call(modal.querySelectorAll('[data-uf-slot]')); }
  // checkbox slots are on when ticked; opt-in slots (no checkbox) count as on once a tile is picked
  function qsSlotOn(slot) { var cb = slot.querySelector('[data-uf-slot-on]'); return cb ? cb.checked : !!slot._vars; }
  function qsSlotWord(slot) { var g = slot.getAttribute('data-uf-slot') || 'item'; return g.charAt(0).toUpperCase() + g.slice(1); }
  function qsSlotColorBtns(slot) { return [].slice.call(slot.querySelectorAll('[data-uf-slot-colors] .uf-qs__color')); }
  function qsSlotSizeBtns(slot) { return [].slice.call(slot.querySelectorAll('[data-uf-slot-sizes] .uf-qs__size')); }
  function qsTopSizeVal(modal) { var s = modal.querySelector('.uf-qs__opt .uf-qs__size.is-sel'); return s && s.getAttribute('data-value'); }
  function qsSlotLabels(slot) {
    var c = slot.querySelector('[data-uf-slot-colorval]'); if (c) c.textContent = slot._color || '';
    var z = slot.querySelector('[data-uf-slot-sizeval]'); if (z) z.textContent = slot._size || '';
  }
  // Strike-through + disable any top color/size that has no available variant (given the current color).
  function qsRefreshTop(modal) {
    var vs = modal._variants || [];
    var colGrp = modal.querySelector('.uf-qs__opt .uf-qs__colors');
    var cpos = colGrp && colGrp.getAttribute('data-option-position');
    var szGrp = modal.querySelector('.uf-qs__opt .uf-qs__sizes');
    var spos = szGrp && szGrp.getAttribute('data-option-position');
    if (colGrp) [].forEach.call(colGrp.querySelectorAll('.uf-qs__color'), function (b) {
      var oos = !vs.some(function (v) { return String(v['option' + cpos]) === String(b.getAttribute('data-value')) && v.available; });
      b.classList.toggle('is-oos', oos); b.disabled = oos;
    });
    if (szGrp) [].forEach.call(szGrp.querySelectorAll('.uf-qs__size'), function (b) {
      var val = b.getAttribute('data-value');
      var oos = !vs.some(function (v) {
        if (String(v['option' + spos]) !== String(val)) return false;
        if (cpos && modal._color && String(v['option' + cpos]) !== String(modal._color)) return false;
        return v.available;
      });
      b.classList.toggle('is-oos', oos); b.disabled = oos;
      if (oos && b.classList.contains('is-sel')) { b.classList.remove('is-sel'); if (modal._sel) delete modal._sel[spos]; }
    });
  }
  // Every tile in a slot shows the color that slot is browsing: the shopper's own pick once they
  // have chosen one, otherwise the main item's color.
  function qsRefreshSlot(slot, modal) {
    var browse = (slot._dirty && slot._color) ? slot._color : modal._color;
    [].forEach.call(slot.querySelectorAll('.uf-qs__partner'), function (pr) {
      var cpos = pr.getAttribute('data-color-pos'), vars = qsVarsFor(pr);
      var oos = !qsColorHasStock(vars, cpos, browse) && !qsColorHasStock(vars, cpos, null);
      pr.classList.toggle('is-oos', oos); pr.disabled = oos;
      var img = pr.querySelector('img');
      var src = qsImgForColor(vars, cpos, browse, 300) || qsImgForColor(vars, cpos, null, 300);
      if (img && src) { img.src = src; if (img.srcset) img.srcset = ''; }
    });
    var sel = slot.querySelector('.uf-qs__partner.is-sel');
    if (sel && sel.classList.contains('is-oos')) qsSlotClear(slot, modal);
  }
  function qsSlotClear(slot, modal) {
    if (modal) { slot._vars = null; qsSwapImage(modal); } // hand the big image back to the main item
    var sel = slot.querySelector('.uf-qs__partner.is-sel');
    if (sel) sel.classList.remove('is-sel');
    slot._vars = null; slot._cpos = ''; slot._spos = ''; slot._color = null; slot._size = null; slot._dirty = false;
    var ss = slot.querySelector('.uf-qs__setsize'); if (ss) ss.hidden = true;
  }
  // Colors from the chosen tile's variants; strike colors with no stock at all.
  function qsSlotBuildColors(slot) {
    var wrap = slot.querySelector('[data-uf-slot-colors]'), outer = slot.querySelector('[data-uf-slot-color-wrap]');
    if (!wrap) return;
    var cpos = slot._cpos, variants = slot._vars || [];
    if (!cpos) { wrap.innerHTML = ''; if (outer) outer.hidden = true; return; }
    var seen = {}, order = [];
    variants.forEach(function (v) { var val = v['option' + cpos]; if (val != null && !seen[val]) { seen[val] = true; order.push(val); } });
    wrap.innerHTML = order.map(function (val) {
      var safe = qsEsc(val), oos = !variants.some(function (v) { return String(v['option' + cpos]) === String(val) && v.available; });
      return '<button type="button" class="uf-qs__color' + (oos ? ' is-oos' : '') + '" data-value="' + safe + '" title="' + safe + '" aria-label="' + safe + '"' + (oos ? ' disabled' : '') + '><span class="uf-qs__dot" style="background:' + dotColor(val) + '"></span></button>';
    }).join('');
    if (outer) outer.hidden = false;
  }
  // Sizes for the chosen color; strike sizes OOS in that color.
  function qsSlotBuildSizes(slot) {
    var wrap = slot.querySelector('[data-uf-slot-sizes]'); if (!wrap) return;
    var spos = slot._spos, variants = slot._vars || [], cpos = slot._cpos, color = slot._color;
    if (!spos) { wrap.innerHTML = ''; return; }
    var seen = {}, order = [];
    variants.forEach(function (v) { var val = v['option' + spos]; if (val != null && !seen[val]) { seen[val] = true; order.push(val); } });
    wrap.innerHTML = order.map(function (val) {
      var safe = qsEsc(val);
      var oos = !variants.some(function (v) {
        if (String(v['option' + spos]) !== String(val)) return false;
        if (cpos && color && String(v['option' + cpos]) !== String(color)) return false;
        return v.available;
      });
      return '<button type="button" class="uf-qs__size' + (oos ? ' is-oos' : '') + '" data-value="' + safe + '"' + (oos ? ' disabled' : '') + '>' + safe + '</button>';
    }).join('');
  }
  // Shopper picked a color for this slot: rebuild sizes, keep the size if still valid else first available.
  function qsSlotSetColor(slot, colorVal) {
    slot._color = colorVal;
    var cb = qsSlotColorBtns(slot).filter(function (b) { return b.getAttribute('data-value') === colorVal; })[0];
    if (cb) qsSelectInGroup(cb);
    qsSlotBuildSizes(slot);
    var btns = qsSlotSizeBtns(slot);
    var keep = slot._size ? btns.filter(function (b) { return b.getAttribute('data-value') === slot._size && !b.disabled; })[0] : null;
    var pick = keep || btns.filter(function (b) { return !b.disabled; })[0];
    if (pick) { qsSelectInGroup(pick); slot._size = pick.getAttribute('data-value'); } else { slot._size = null; }
    qsSlotLabels(slot);
  }
  // Mirror the main item's color+size onto the slot — until the shopper touches the slot itself.
  function qsSlotMirror(slot, modal) {
    if (!slot._vars || slot._dirty) return;
    var vs = slot._vars;
    if (slot._cpos) {
      var want = modal._color;
      var hasWant = want && vs.some(function (v) { return String(v['option' + slot._cpos]) === String(want) && v.available; });
      var firstColorBtn = qsSlotColorBtns(slot).filter(function (b) { return !b.disabled; })[0];
      slot._color = hasWant ? want : (firstColorBtn ? firstColorBtn.getAttribute('data-value') : null);
      var cb = qsSlotColorBtns(slot).filter(function (b) { return b.getAttribute('data-value') === slot._color; })[0];
      if (cb) qsSelectInGroup(cb);
      qsSlotBuildSizes(slot);
    }
    if (slot._spos) {
      var wantS = qsTopSizeVal(modal), btns = qsSlotSizeBtns(slot);
      var pick = wantS ? btns.filter(function (b) { return b.getAttribute('data-value') === wantS && !b.disabled; })[0] : null;
      if (!pick) pick = btns.filter(function (b) { return !b.disabled; })[0];
      if (pick) { qsSelectInGroup(pick); slot._size = pick.getAttribute('data-value'); } else { slot._size = null; }
    }
    qsSlotLabels(slot);
  }
  function qsSlotSelectTile(slot, pr, modal, quiet) {
    if (pr.disabled || pr.classList.contains('is-oos')) return;
    if (pr.classList.contains('is-sel')) { qsSlotClear(slot, modal); return; } // tapping the + again drops the add-on
    qsSelectInGroup(pr);
    slot._vars = qsVarsFor(pr).slice();
    slot._cpos = pr.getAttribute('data-color-pos') || '';
    slot._spos = pr.getAttribute('data-size-pos') || '';
    var keepColor = slot._dirty ? slot._color : null; // stay on the color this slot is browsing
    slot._color = null; slot._size = null; slot._dirty = false;
    qsSlotBuildColors(slot);
    qsSlotBuildSizes(slot);
    var ss = slot.querySelector('.uf-qs__setsize'); if (ss) ss.hidden = false;
    if (keepColor && qsColorHasStock(slot._vars, slot._cpos, keepColor)) {
      slot._dirty = true; qsSlotSetColor(slot, keepColor);
    } else {
      qsSlotMirror(slot, modal);
    }
    qsRefreshSlot(slot, modal);
    if (!quiet) qsSlotShowImage(slot, modal); // on open the big image stays on the main item
  }
  // A slot that is switched on with nothing picked yet takes the first in-stock tile.
  function qsSlotAutoPick(slot, modal, quiet) {
    if (!qsSlotOn(slot) || slot._vars) return;
    var fp = slot.querySelector('.uf-qs__partner:not([disabled])');
    if (fp) qsSlotSelectTile(slot, fp, modal, quiet);
  }
  function qsUpdate(modal) {
    var addBtn = modal.querySelector('.uf-qs__add'), idInput = modal.querySelector('input[name="id"]');
    var m = qsMainMatch(modal);
    if (m.variant && idInput) idInput.value = m.variant.id;
    if (!m.complete) { qsNeeds(modal, 'Select ' + m.needLabel, m.needEl); return; }
    qsNeeds(modal, null, null);
    if (!m.variant) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
    if (!m.variant.available) { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; return; }

    var addons = [], pending = null, pendingEl = null;
    qsSlots(modal).forEach(function (slot) {
      var r = qsSlotMatch(slot); if (!r) return;
      var w = qsSlotWord(slot);
      function need(text, el) { if (!pending) { pending = text; pendingEl = el; } }
      if (r.needPartner) { need('Choose ' + ('AEIOU'.indexOf(w.charAt(0)) > -1 ? 'An ' : 'A ') + w, slot.querySelector('.uf-qs__partners')); return; }
      if (r.needColor) { need('Select ' + w + ' Color', slot.querySelector('[data-uf-slot-color-wrap]')); return; }
      if (r.needSize) { need('Select ' + w + ' Size', slot.querySelector('[data-uf-slot-sizes]')); return; }
      if (!r.variant || !r.variant.available) { need(w + ' Unavailable', slot); return; }
      addons.push({ id: r.variant.id, group: w });
    });
    modal._addons = addons;
    if (pending) { qsNeeds(modal, pending, pendingEl); return; }
    qsNeeds(modal, null, null);
    addBtn.disabled = false;
    addBtn.textContent = addons.length ? 'Add ' + (addons.length + 1) + ' Items' : 'Add To Cart';
  }
  // Name the next missing choice on the button and remember where it lives, so tapping the
  // button walks the shopper to it instead of doing nothing.
  function qsNeeds(modal, label, el) {
    var addBtn = modal.querySelector('.uf-qs__add');
    modal._needEl = label ? (el || null) : null;
    if (!label) { addBtn.classList.remove('is-needs'); return; }
    addBtn.disabled = false;
    addBtn.classList.add('is-needs');
    addBtn.textContent = label;
  }
  function qsGoToNeed(modal) {
    var el = modal._needEl; if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.classList.add('uf-qs__flash');
    setTimeout(function () { el.classList.remove('uf-qs__flash'); }, 1400);
    var first = el.querySelector('button:not([disabled])');
    if (first) { try { first.focus({ preventScroll: true }); } catch { first.focus(); } }
  }
  function qsOpen(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    if (!modal._init) {
      modal._init = true; modal._sel = {};
      try { modal._variants = JSON.parse(modal.querySelector('.uf-qs__variants').textContent); }
      catch { modal._variants = []; }
      [].forEach.call(modal.querySelectorAll('.uf-qs__color'), function (b) {
        var d = b.querySelector('.uf-qs__dot'); if (d) d.style.background = dotColor(b.getAttribute('data-value'));
      });
    }
    modal._lastFocus = document.activeElement;
    modal._optsFocused = false;
    modal.hidden = false; modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    qsRefreshTop(modal);
    qsSlots(modal).forEach(function (slot) { // slots that start on reveal + pre-pick their first in-stock tile
      qsRefreshSlot(slot, modal);
      if (!qsSlotOn(slot)) return;
      var opts = slot.querySelector('.uf-qs__setopts'); if (opts) opts.hidden = false;
      qsSlotAutoPick(slot, modal, true);
    });
    qsUpdate(modal);
    var close = modal.querySelector('.uf-qs__close'); if (close) close.focus();
  }
  function qsClose(modal) {
    if (!modal) return;
    modal.hidden = true; modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (modal._lastFocus && modal._lastFocus.focus) { try { modal._lastFocus.focus(); } catch { /* Focus target may be detached. */ } }
  }
  // Mobile only: scroll the option block that owns `el` to the top of the panel.
  // Once per open — re-picking a color shouldn't yank the panel back every time.
  function qsFocusOptions(el) {
    if (!window.matchMedia('(max-width:860px)').matches) return;
    var modal = el.closest('.uf-qs');
    if (!modal || modal._optsFocused) return;
    modal._optsFocused = true;
    var opt = el.closest('.uf-qs__opt');
    if (opt) opt.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function qsSelectInGroup(el) {
    [].forEach.call(el.parentNode.children, function (x) { x.classList.remove('is-sel'); });
    el.classList.add('is-sel');
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.uf-card__swatch');
    if (sw) {
      var card = sw.closest('.uf-card'); var cimg = card && card.querySelector('.uf-card__media img');
      var csrc = sw.getAttribute('data-img');
      if (cimg && csrc) { cimg.src = csrc; if (cimg.srcset) cimg.srcset = ''; }
      [].forEach.call(sw.parentNode.querySelectorAll('.uf-card__swatch'), function (b) { b.classList.remove('is-sel'); });
      sw.classList.add('is-sel');
      return;
    }
    var need = e.target.closest('.uf-qs__add.is-needs');
    if (need) { e.preventDefault(); e.stopPropagation(); qsGoToNeed(need.closest('.uf-qs')); return; }
    var o = e.target.closest('[data-uf-qs-open]'); if (o) { e.preventDefault(); qsOpen(o.getAttribute('data-uf-qs-open')); return; }
    var c = e.target.closest('[data-uf-qs-close]'); if (c) { qsClose(c.closest('.uf-qs')); return; }
    // add-on slots own their tiles/colors/sizes; handled before the main option groups
    var slot = e.target.closest('[data-uf-slot]');
    if (slot) {
      var sm = slot.closest('.uf-qs');
      var sPr = e.target.closest('.uf-qs__partner');
      if (sPr) { qsSlotSelectTile(slot, sPr, sm); qsUpdate(sm); return; }
      var sCol = e.target.closest('.uf-qs__color');
      if (sCol) { if (!sCol.disabled) { slot._dirty = true; qsSlotSetColor(slot, sCol.getAttribute('data-value')); qsRefreshSlot(slot, sm); qsSlotShowImage(slot, sm); qsUpdate(sm); } return; }
      var sSz = e.target.closest('.uf-qs__size');
      if (sSz) {
        if (sSz.disabled) return;
        qsSelectInGroup(sSz); slot._size = sSz.getAttribute('data-value'); slot._dirty = true;
        qsSlotLabels(slot); qsUpdate(sm); return;
      }
      return;
    }
    var col = e.target.closest('.uf-qs__color');
    if (col) {
      if (col.disabled) return;
      var m = col.closest('.uf-qs');
      qsSelectInGroup(col);
      var pos = col.closest('[data-option-position]').getAttribute('data-option-position');
      m._sel = m._sel || {}; m._sel[pos] = col.getAttribute('data-value'); m._color = col.getAttribute('data-value');
      var lbl = m.querySelector('[data-uf-qs-colorval]'); if (lbl) lbl.textContent = m._color;
      qsSwapImage(m);
      qsFocusOptions(col); // mobile: the 2:3 image is tall — bring the selectors up
      qsRefreshTop(m); // strike sizes that are OOS for this color
      qsSlots(m).forEach(function (sl) { qsRefreshSlot(sl, m); qsSlotMirror(sl, m); });
      qsUpdate(m); return;
    }
    var sz = e.target.closest('.uf-qs__size');
    if (sz) {
      if (sz.disabled) return;
      var m2 = sz.closest('.uf-qs'); qsSelectInGroup(sz);
      var pos2 = sz.closest('[data-option-position]').getAttribute('data-option-position');
      m2._sel = m2._sel || {}; m2._sel[pos2] = sz.getAttribute('data-value');
      qsSlots(m2).forEach(function (sl) { qsSlotMirror(sl, m2); });
      qsUpdate(m2); return;
    }
  });
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-uf-slot-on]');
    if (!cb) return;
    var slot = cb.closest('[data-uf-slot]'), modal = slot.closest('.uf-qs');
    var opts = slot.querySelector('.uf-qs__setopts');
    if (cb.checked) {
      if (opts) opts.hidden = false;
      qsRefreshSlot(slot, modal);
      qsSlotAutoPick(slot, modal);
    } else {
      if (opts) opts.hidden = true;
      qsSlotClear(slot, modal);
    }
    qsUpdate(modal);
  });
  document.addEventListener('keydown', function (e) {
    var open = document.querySelector('.uf-qs:not([hidden])');
    if (!open) return;
    if (e.key === 'Escape') { qsClose(open); return; }
    if (e.key === 'Tab') { // focus trap
      var f = [].filter.call(
        open.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!open.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  // Add: for a set, add the partner via /cart/add.js first, then let the NATIVE product-form
  // add the main item (which dispatches variant:add → the theme's cart drawer opens with both).
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('.uf-qs__form');
    if (!f) return;
    var modal = f.closest('.uf-qs');
    if (modal._needEl) { e.preventDefault(); e.stopImmediatePropagation(); qsGoToNeed(modal); return; }
    if (modal._bundleAdding) { modal._bundleAdding = false; setTimeout(function () { qsClose(modal); }, 80); return; }
    var addons = modal._addons || [];
    if (addons.length) {
      e.preventDefault(); e.stopImmediatePropagation();
      modal._bundleAdding = true;
      var source = modal.getAttribute('data-uf-source'); // only tagged where the section asked for it
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: addons.map(function (a) {
            var item = { id: a.id, quantity: 1 };
            if (source) item.properties = { _added_from: source + ' — ' + a.group + ' add-on' };
            return item;
          })
        })
      })
        .then(function () { if (f.requestSubmit) f.requestSubmit(); else modal.querySelector('.uf-qs__add').click(); })
        .catch(function () { modal._bundleAdding = false; });
      return;
    }
    setTimeout(function () { qsClose(modal); }, 80);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // Theme editor: re-init when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
